"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var LoaderSpinner_1 = require("./LoaderSpinner");
var styled_components_1 = __importDefault(require("styled-components"));
var Text_1 = require("../Text/Text");
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
var getTextPosition = function (position) {
    var result;
    switch (position) {
        case 'top':
            result = 'column-reverse';
            break;
        case 'bottom':
            result = 'column';
            break;
        case 'left':
            result = 'row-reverse';
            break;
        case 'right':
            result = 'row';
            break;
        default:
            result = 'column';
    }
    return result;
};
var LoaderStyles = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  width: max-content;\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n"], ["\n  ", "\n  ", "\n  width: max-content;\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n"])), margin_1.default, padding_1.default, function (props) { return getTextPosition(props.textPosition); });
var Loader = function (_a) {
    var isLoading = _a.isLoading, size = _a.size, borderWidth = _a.borderWidth, loadingText = _a.loadingText, spinnerMargin = _a.spinnerMargin, props = __rest(_a, ["isLoading", "size", "borderWidth", "loadingText", "spinnerMargin"]);
    return isLoading !== false ? (React.createElement(LoaderStyles, __assign({}, props),
        React.createElement(LoaderSpinner_1.LoaderSpinner, { size: size, borderWidth: borderWidth, margin: spinnerMargin }),
        loadingText ? (React.createElement(Text_1.Text, { color: "BRAND_BLACK", lg: true }, loadingText)) : null)) : null;
};
exports.default = Loader;
var templateObject_1;
